<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Cari Tel</label>
            <input class="form-control" v-mask="phoneMask" type="text" v-model="value.CariPhone" placeholder="Cari Tel" />
        </div>
        <div class="col-12" :class="{ 'mb-1': canEditDeliveryPhone }">
            <label class="form-label">Cari E-Posta</label>
            <input class="form-control" :class="{ 'is-invalid': emailInvalid }" type="text" v-model="value.CariEmail" placeholder="Cari E-Posta"/>
            <small v-if="emailInvalid" class="text-danger">Lütfen geçerli bir e-posta adresi giriniz.</small>
        </div>
        <div class="col-12" v-if="canEditDeliveryPhone">
            <label class="form-label">Teslim Telefon Numarası</label>
            <input class="form-control" v-mask="phoneMask" type="text" v-model="value.CariDeliveryPhone" placeholder="Teslim Telefon Numarası" />
        </div>
    </div>
</template>

<script>
import Auth from '@/utilities/auth'
export default {
    props:{
        value:Object
    },
    data(){
        return{
            phoneMask:'(###) ### ## ##',
        }
    },
    computed:{
        canEditDeliveryPhone(){
            return Auth.hasRole(['EDIT_CUSTOMER_DELIVERY_PHONE'])
        },
        emailInvalid(){
            let email = this.value?.CariEmail?.trim()
            if(!email) return false
            return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        }
    }
}
</script>

<style>

</style>
